var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.layoutClass},[_c('main',{staticClass:"auth-layout__content"},[_c('common-content-spacer',{attrs:{"height":"medium"}},[_vm._t("default")],2),(_vm.showTerms)?_c('terms-of-use'):_vm._e()],1),_c('portal-target',{attrs:{"name":"modals"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }